module.exports = __webpack_public_path__ + "img/btn_menu_gwsh_c.4155cfb6.png";